import React, {useEffect, useState} from 'react';
import {Button, Card, Header, Input} from 'semantic-ui-react';
import EmptyData from './emptyData';
import HeaderModule from './header';
import SearchCustomer from './search/search';
import './styles.scss';
import TimeLine from './timeLine';
import {connect} from 'react-redux';
import {Actions} from '../../common/actions';

const CustomerTracking = ({
  customerData,
  clearCustomerTrackingState,
  fetchCustomerTracking,
  loading,
}) => {
  const [id, setId] = useState('');
  const handleSend = () => {
    fetchCustomerTracking(id);
  };
  useEffect(() => {
    clearCustomerTrackingState();
  }, []);
  return <>
    <HeaderModule />
    <Card fluid className='main-container-customer'>
      <div className='customer-seach-container'>
        <div className='customer-seach'>
          <Header size='small' className='mtd-2'>BUSCAR CLIENTE</Header>
          <Input
            placeholder='INGRESE LA CEDULA DEL CLIENTE'
            size='mini'
            value={id}
            onChange={(_, {value}) => setId(value)}
          />
          <Button
            size='mini'
            onClick={handleSend}
          >BUSCAR</Button>
        </div>
        {
          customerData.length ? customerData?.map((vehicle) => (
            <div className='customer-vehicle-info'>
              <SearchCustomer data={vehicle?.resultInf || {}} />
              {!vehicle ?
                <EmptyData loading={loading} /> :
                <TimeLine timeLineData={vehicle?.resultTracking} />
              }
            </div>
          )) : <EmptyData loading={loading} />
        }
      </div>
    </Card>
  </>;
};

const {
  fetchCustomerTracking,
  clearCustomerTrackingState,
} = Actions;

const mapStateToProps = (state) => {
  return {
    'customerData': state.customerTracking.customerData,
    'loading': state.customerTracking.loading,
  };
};

export default connect(mapStateToProps, {fetchCustomerTracking, clearCustomerTrackingState})(CustomerTracking);
